import React from "react"
import { Link } from "react-router-dom"
import { buildModuleVOOverviewUrl } from "../moduleVoNavigation"
import { useModuleVOEditParams } from "../hooks/useModuleVOEditParams"
import FixedFees from "../components/FixedFees"

export default function EditFixedFees() {
    const { brand, dealershipIds, scope } = useModuleVOEditParams()

    return (
        <div className="container-fluid mb-2">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Édition — Frais fixes</h4>
                <Link to={buildModuleVOOverviewUrl('fixedFees')} className="btn btn-outline-secondary btn-sm">
                    <i className="fa fa-arrow-left tw-mr-2"></i>
                    Retour
                </Link>
            </div>

            <FixedFees mode="edit" scope={scope} brand={brand} dealershipIds={dealershipIds} />
        </div>
    )
}
